<template>
  <v-card class="mb-4" flat>
    <validation-observer ref="obs" v-slot="{ invalid }">
      <v-card-text>
        <!--
        <v-row>
            <v-col cols="12">
              <validation-provider
                vid="disabled"
                :name="$t('disabled')"
                v-slot="{ errors, valid, dirty, classes }"
              >
                <v-switch
                  v-model="item.disabled"
                  name="disabled"
                  :label="$t('disabled')"
                  :error-messages="errors"
                  :class="classes"
                  dense
                />
              </validation-provider>
            </v-col>
        </v-row>
        -->
        <v-row>
          <v-col cols="6">
            <validation-provider
              vid="dest_pattern"
              :name="$t('dest pattern')"
              rules="required"
              v-slot="{ errors, valid, dirty, classes }"
            >
              <v-select
                v-model="item.dest_pattern"
                :items="numbers"
                item-text="national_number"
                item-value="national_number"
                name="dest_pattern"
                :label="$t('dest pattern')"
                :error-messages="errors"
                :class="classes"
                :disabled="item && item.disabled"
                single-line
                clearable
              />
            </validation-provider>
          </v-col>
           <v-col cols="6">
            <validation-provider
              vid="type"
              :name="$t('type')"
              rules="required"
              v-slot="{ errors, valid, dirty, classes }"
            >
              <v-select
                v-model="item.type"
                :items="types"
                item-text="text"
                item-value="value"
                name="type"
                :label="$t('type')"
                :error-messages="errors"
                :class="classes"
                :disabled="item && item.disabled"
                single-line
              />
            </validation-provider>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <v-col :cols="item && item.to_mailbox ? 12 : 6" align="center" justify="center">
              <validation-provider
                vid="to_mailbox"
                :name="$t('to mailbox')"
                v-slot="{ errors, valid, dirty, classes }"
              >
                <v-switch
                  v-model="item.to_mailbox"
                  name="to_mailbox"
                  :label="$t('to mailbox')"
                  :error-messages="errors"
                  :class="classes"
                  :disabled="item && item.disabled"
                  dense
                  @change="item.dest_replace = item.dest_pattern == item.dest_replace ? '' : item.dest_replace"
                />
              </validation-provider>
            </v-col>
          <v-col cols="6" v-if="!(item && item.to_mailbox)" align="center" justify="center">
            <validation-provider
              vid="dest_replace"
              :name="$t('dest replace mailbox')"
              rules="required|phone"
              v-slot="{ errors, valid, dirty, classes }"
            >
              <v-text-field
                ref="destReplaceInput"
                v-model="item.dest_replace"
                name="dest_replace"
                :label="$t('dest replace')"
                :error-messages="errors"
                :class="classes"
                :disabled="item && item.disabled"
                hide-details="auto"
                dense
              />
            </validation-provider>
          </v-col>
        </v-row>

        <v-row>
           <v-col cols="12" v-if="item.type == 'CFNR'">
            <validation-provider
                vid="delay"
                :name="$t('delay')"
                v-slot="{ errors, valid, dirty, classes }"
              >
               <v-slider
                  v-model="item.delay"
                  name="delay"
                  :label="$t('delay')"
                  :error-messages="errors"
                  :class="classes"
                  :disabled="item && item.disabled"
                  thumb-color="primary"
                  thumb-label="always"
                  :thumb-size="20"
                  always-dirty
                  max="120"
                  min="10"
                >
                  <template v-slot:prepend>
                    <v-icon
                      @click="decrement('delay')"
                    >
                    mdi-minus
                  </v-icon>
                  </template>
                  <template v-slot:append>
                    <v-icon
                      @click="increment('delay')"
                    >
                      mdi-plus
                    </v-icon>
                  </template>
                </v-slider>
              </validation-provider>
           </v-col>
           <!--
           <v-col cols="6">
            <validation-provider
                vid="priority"
                :name="$t('priority')"
                v-slot="{ errors, valid, dirty, classes }"
              >
               <v-slider
                  v-model="item.priority"
                  name="priority"
                  :label="$t('priority')"
                  :error-messages="errors"
                  :class="classes"
                  :disabled="item && item.disabled"
                  thumb-color="primary"
                  thumb-label="always"
                  :thumb-size="20"
                  always-dirty
                  max="10"
                  min="0"
                >
                  <template v-slot:prepend>
                    <v-icon
                      @click="decrement('priority')"
                    >
                    mdi-minus
                  </v-icon>
                  </template>
                  <template v-slot:append>
                    <v-icon
                      @click="increment('priority')"
                    >
                      mdi-plus
                    </v-icon>
                  </template>
                </v-slider>
              </validation-provider>
           </v-col>
           -->
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn v-if="item && item.id" :disabled="loading"  @click="deleteItem" text>
          {{ $t("delete") }}
        </v-btn>
        <v-spacer />
        <v-btn :disabled="loading" @click="$emit('cancel')"" text>
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          :disabled="invalid || loading"
          :loading="loading"
          @click="item && item.id ? updateItem() : createItem()"
          text
        >
          {{ item && item.id ? $t("save") : $t("create")}}
        </v-btn>
      </v-card-actions>
    </validation-observer>
  </v-card>
</template>

<script>
import formatDate from "@/utils/mixins/formatDate";
import showErrors from "@/utils/mixins/showErrors";
import isMobile from "@/utils/mixins/isMobile";
import BooleanValue from "@/components/basics/BooleanValue";
import DatePicker from "@/components/basics/DatePicker";

export default {
  name: "CallForward",
  mixins: [formatDate, showErrors, isMobile],
  components: { BooleanValue, DatePicker, },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    productId: {
      validator: (prop) => typeof prop === "string" || typeof prop === "number",
    },
    emptyCallForward: {
      type: Object,
      required: true,
      default: () => {},
    },
    types: {
      type: Array,
      required: true,
      default: () => [],
    },
    numbers: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => ({
    item: {},
    loadingItem: false,
    updatingItem: false,
    creatingItem: false,
    deletingItem: false,
  }),
  computed: {
    loading() {
      return (
        this.loadingItem ||
        this.updatingItem ||
        this.creatingItem ||
        this.deletingItem
      );
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.setItem(value);
      },
    },
  },
  methods: {
    decrement(name) {
      this.item[name]--
    },
    increment(name) {
      this.item[name]++
    },
    setItem(value) {
      if (value) {
        const to_mailbox = value.dest_replace && value.dest_replace.startsWith("*86")
          ? true
          : false;
        const dest_replace = to_mailbox
          ? value.dest_replace.replace(/^\*86/, "")
          : value.dest_replace;
        this.item = {
          ...value,
          to_mailbox: to_mailbox,
          dest_replace: dest_replace,
        };
      } else this.item = {
        ...emptyCallForward,
      };
    },
    getItem() {
      var that = this;
      that.loadingItem = true;
      this.$http
        .get(
          "services/voip/" + this.productId + "/call-forwards/" + this.value.id
        )
        .then((response) => {
          that.item = response.data;
        })
        .catch((err) => {
          that.$store.commit("setSystemError", {
            msg: err.message,
            title: err.title,
          });
        })
        .finally(function () {
          that.loadingItem = false;
        });
    },
    getData() { 
      return {
        ...this.item,
        dest_replace: this.item && this.item.to_mailbox
          ? "*86" + this.item.dest_pattern
          : this.item
            ? this.item.dest_replace
            : null,
      };
    },
    updateItem() {
      var that = this;
      this.updatingItem = true;
      this.$http
        .patch(
          "services/voip/" + this.productId + "/call-forwards/" + this.item.id,
          this.getData()
        )
        .then((response) => {
          that.setItem(response.data);
          that.$emit("update", that.item);
        })
        .catch((error) => {
          that.$store.commit("setSystemError", {
            msg: error.message,
            title: error.title,
          });
        })
        .finally(function () {
          that.updatingItem = false;
        });
    },
    createItem() {
      var that = this;
      this.updatingItem = true;
      this.$http
        .post("services/voip/" + this.productId + "/call-forwards", this.getData())
        .then((response) => {
          that.setItem(response.data);
          that.$emit("created", that.item);
        })
        .catch((error) => {
          that.$store.commit("setSystemError", {
            msg: error.message,
            title: error.title,
          });
        })
        .finally(function () {
          that.creatingItem = false;
        });
    },
    deleteItem() {
      var that = this;
      this.deletingItem = true;
      this.$http
        .delete(
          "services/voip/" + this.productId + "/call-forwards/" + this.item.id
        )
        .then((response) => {
          that.item = null;
          that.$emit("deleted");
        })
        .catch((error) => {
          that.$store.commit("setSystemError", {
            msg: error.message,
            title: error.title,
          });
        })
        .finally(function () {
          that.deleteItem = false;
        });
    },
  },
};
</script>

<i18n>
{
  "en": {
    "name": "Name",
    "type": "Type",
    "priority": "Priority",
    "dest pattern": "Destination number",
    "dest replace": "Forward to",
    "dest replace mailbox": "Forward to mailbox",
    "source pattern": "Source pattern",
    "source presentation pattern": "Source presentation pattern",
    "time pattern": "Time pattern",
    "reject pattern": "Reject pattern",
    "delay": "Ring duration in seconds",
    "propagate busy": "Propagate busy",
    "parallel call": "Parallel call",
    "always ring": "Always ring",
    "early media": "Early media",
    "last diversion": "Last diversion",
    "reroute": "Reroute",
    "suspended": "Suspended",
    "disabled": "Disabled",
    "start date": "Start date",
    "end date": "End date",
    "delay": "Delay",
    "cancel": "Cancel",
    "save": "Save",
    "create": "Create",
    "delete": "Delete",
    "to mailbox": "To Mailbox"
  },
  "de": {
    "name": "Name",
    "type": "Typ",
    "priority": "Priorität",
    "dest pattern": "Rufnummer",
    "dest replace": "Umleitung auf",
    "dest replace mailbox": "Umleitung auf Mailbox",
    "source pattern": "Source Pattern",
    "source presentation pattern": "Source Presentation Pattern",
    "dest replace mailbox": "Zielnummer",
    "time pattern": "Time Pattern",
    "reject pattern": "Reject Pattern",
    "delay": "Klingeldauer in Sekunden",
    "propagate busy": "Propagiere beschäftigt",
    "parallel call": "Paralleler Anruf",
    "always ring": "Immer klingeln",
    "early media": "Early Media",
    "last diversion": "Letzte Umleitung",
    "reroute": "Umleiten",
    "suspended": "Ausgesetzt",
    "disabled": "Deaktiviert",
    "start date": "Startdatum",
    "end date": "Enddatum",
    "delay": "Verzögerung",
    "cancel": "Abbruch",
    "save": "Speichern",
    "create": "Anlegen",
    "delete": "Löschen",
    "to mailbox": "auf Mailbox"
  }
}
</i18n>
